var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIssueSelected = function SvgIssueSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 1a.75.75 0 0 0-1.5 0v20a.75.75 0 0 0 1.5 0v-8.15l1.887-.377c1.52-.305 3.1-.031 4.43.767a6.233 6.233 0 0 0 5.993.23l.447-.223a.893.893 0 0 0 .493-.799V3.696a.43.43 0 0 0-.622-.385l-.318.159a6.233 6.233 0 0 1-5.994-.23 6.233 6.233 0 0 0-4.429-.767L1.75 2.85V1Z",
    fill: "#050400"
  })));
};
export default SvgIssueSelected;